import * as RequestConstants from "@/constants/request";

export function setRequestInProcess(inProcess, requestType) {
  return {
    type: RequestConstants.SET_REQUEST_IN_PROCESS,
    requestType,
    inProcess
  };
}